import { motion, Transition } from 'framer-motion';
import { ReactNode } from 'react';

import { Box } from '@bonusly/design-system';

const MIN_HEIGHT = 220;

const MotionBox = motion.create(Box);

interface AnimatedBoxProps {
	children: ReactNode;
	minH?: number;
}

export function AnimatedBox({ children, minH = MIN_HEIGHT }: AnimatedBoxProps) {
	const variants = {
		enter: { opacity: 0.2, height: minH },
		center: { opacity: 1, height: 'auto' },
		exit: { opacity: 0.2, height: minH },
	};
	const transition: Transition = { duration: 0.15, ease: 'easeInOut', type: 'tween' };

	return (
		<MotionBox variants={variants} initial="enter" animate="center" exit="exit" transition={transition} minH={minH}>
			{children}
		</MotionBox>
	);
}
